<div class="loader">
	<svg class="spinner" xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240" fill="none">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M120 56C84.6538 56 56 84.6538 56 120C56 155.346 84.6538 184 120 184C155.346 184 184 155.346 184 120C184 110.814 182.07 102.101 178.6 94.2253L193.242 87.7747C197.59 97.6437 200 108.551 200 120C200 164.183 164.183 200 120 200C75.8172 200 40 164.183 40 120C40 75.8172 75.8172 40 120 40V56Z"
			fill="#FF7900"
		/>
	</svg>
	<div class="loader__text">
		<h3 *ngIf="title" [innerHTML]="title"></h3>
		<span *ngIf="subtitle" [innerHTML]="subtitle"></span>
	</div>
</div>
